import * as React from "react";
import {Customer, Gender} from "../../../../../domain/model/customer";
import {customerConfig} from "../../../../../config/language/ja-JP/domain/model_text";
import styled from "styled-components";
import {ConstColor} from "../../../../../config/styles_const/styles_const";
import AvatarMiddle from "../../../../common/atom/avatar/avatar_middle";
import HeadlineSmall from "../../../../common/atom/text/headline_small";
import ParagraphSup from "../../../../common/atom/text/paragraph_sup";

interface IProps {
    customer: Customer;
}

const ContractCustomerContent: React.FC<IProps> = (props) => {

    const {customer } = props;

    const customerName: string = customer.name;
    const customerIconURL: string = customer.getIconURL();
    const customerBirthdate: string = customer.getAgeString();
    const customerGender: Gender = customer.gender;
    const customerAddress: string = customer.address;
    const customerPr: string = customer.pr;

    return(
        <ContractCustomerContentWrapper>
            <CustomerProfileWrapper>
                <CustomerAvatar src={customerIconURL}/>
                <CustomerInfoWrapper>
                    <CustomerAddressAndNameWrapper>
                        { customerAddress && <CustomerAddressAndName>{customerAddress}</CustomerAddressAndName>}
                        <CustomerAddressAndName>{customerName}</CustomerAddressAndName>
                        <CustomerBirthdateAndGender>{customerBirthdate}/{customerConfig.genderList.get(customerGender)}</CustomerBirthdateAndGender>
                    </CustomerAddressAndNameWrapper>
                    <CustomerPr>{customerPr}</CustomerPr>
                </CustomerInfoWrapper>
            </CustomerProfileWrapper>
        </ContractCustomerContentWrapper>
    )
};

export default ContractCustomerContent

const ContractCustomerContentWrapper = styled.div`
    padding-bottom: 30px;
    border-bottom: 1px solid ${ConstColor.PlaceholderAndBorder};
    margin-bottom: 40px;
`;


const CustomerProfileWrapper = styled.div`
    display: flex;
`;

const CustomerAvatar = styled(AvatarMiddle)`
    margin-right: 20px;
`;

const CustomerInfoWrapper = styled.div`
`;

const CustomerAddressAndNameWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 5px;
`;

const CustomerAddressAndName = styled(HeadlineSmall)`
    margin-right: 10px;
`;

const CustomerPr = styled(ParagraphSup)`
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
`;

const CustomerBirthdateAndGender = styled(ParagraphSup)`
    
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/contract/share/contract_customer_content.tsx